import * as Icons from '@mui/icons-material';
import { useMemo } from 'react';

import { HASH_CONFIG_MAP } from '../../utils/hashs/hashConfig';
import { useCurrentHashStore } from '../../stores/hashs/useCurrentHashStore';
import { useAvailableLinesStore } from '../../stores/hashs/useAvailableLinesStore';
import { useNotEscaletedLinesNextStore } from '../../stores/hashs/useNotEscaletedLinesNextStore';
import { useNotEscaletedLinesTodayStore } from '../../stores/hashs/useNotEscaletedLinesTodayStore';
import { useEscaletedLinesTodayStore } from '../../stores/hashs/useEscaletedLinesTodayStore';

export function useCurrentHash() {

    const currentHash = useCurrentHashStore(
        state => state.currentHash
    );

    const availableTitle = useAvailableLinesStore(
        state => state.title
    );

    const notEscaletedLinesNextTitle = useNotEscaletedLinesNextStore(
        state => state.title
    );

    const notEscaletedLinesTodayTitle = useNotEscaletedLinesTodayStore(
        state => state.title
    );

    const escaletedLinesTodayTitle = useEscaletedLinesTodayStore(
        state => state.title
    );

    return useMemo(() => {

        const config = HASH_CONFIG_MAP.get(currentHash) ?? {};

        const icon = config.icon ?? 'Warning';

        let dynamicTitle = null;

        switch (currentHash) {

            case 'linhas-disponiveis':
                dynamicTitle = availableTitle;
                break;
            
            case 'linhas-nao-escaladas-amanha':
                dynamicTitle = notEscaletedLinesNextTitle;
                break;

            case 'linhas-nao-escaladas-hoje':
                dynamicTitle = notEscaletedLinesTodayTitle;
                break;

            case 'viagens-do-dia':
                dynamicTitle = escaletedLinesTodayTitle;
                break;

            default:
                dynamicTitle = null;
                break;
        }

        const hashTitle = config.title || dynamicTitle || '';

        return {
            hashTitle,
            hashColor: config?.color ?? 'primary',
            HashIconComponent: Icons[icon] ?? Icons.Warning,
            hashElemment: config?.elemment ?? 'LineCard',
            hashScheduleType: config?.scheduleType ?? null,
            hashOffset: config?.offset ?? null,
            currentHash
        };

    }, [
        currentHash,
        availableTitle,
        notEscaletedLinesNextTitle,
        notEscaletedLinesTodayTitle,
        escaletedLinesTodayTitle
    ]);

}